<template>
  <r-panel :title="title" :button_add="true" @click_add="row_create">
    <v-row dense>
      <v-col cols="12" md="12" sm="12">
        <v-data-table
            :headers="headers"
            :items="rules"
            :hide-default-header="empty"
            :height="rules.length > 7 ? (32 * 7 + 32 + 16) : undefined"
            disable-pagination dense
            hide-default-footer
            style="white-space: nowrap"
        >
          <template v-slot:item.launchTime="{item}">
            {{ formatDate(item.launchTime) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
            <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
            <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
            <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <v-divider/>
      </v-col>
    </v-row>
    <v-row dense class="mt-4">
      <v-col cols="12" sm="6" md="6">
        <v-checkbox v-model="model.startOnLaunch" label="Start on launch" hide-details/>
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <v-text-field v-model.number="value.profileAge" label="Profile Age" hide-details/>
      </v-col>
    </v-row>
    <r-guard-time-rule-dialog ref="dialog"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {GuardTime} from "@/modules/redactor/models/guard/GuardTime";

import RPanel from "@/modules/redactor/views/utils/r-panel";
import RGuardTimeRuleDialog from "@/modules/redactor/views/guard/r-guard-time-rule-dialog.vue";
import moment from "moment";

export default {
  name: "r-guard-time-panel",
  components: {RGuardTimeRuleDialog, RPanel},
  props: {
    title: VueTypes.string.def("Guard Time"),
    model: VueTypes.instanceOf(GuardTime)
  },
  data: () => ({
    headers: [
      {text: 'Repeat', value: 'repeatInterval.name'},
      {text: 'Launch Time (UTC +0)', value: 'launchTime'},
      {text: 'Pending Time', value: 'pendingTime'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.rules.length === 0;
    },
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new GuardTime();
        this.$emit("update:model", value);
        return value;
      }
    },
    rules() {
      return this.value.rules;
    }
  },
  methods: {
    formatDate(timestamp) {
      return moment.unix(parseInt(timestamp)).utc().format("DD/MM/YYYY HH:mm");
    },

    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.rules.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.rules.indexOf(item);
            this.rules.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.rules.indexOf(item);
        this.rules.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.rules.indexOf(item);
      if (index > 0) {
        this.rules.splice(index - 1, 2, this.rules[index], this.rules[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.rules.indexOf(item);
      if (index < this.rules.length - 1) {
        this.rules.splice(index, 2, this.rules[index + 1], this.rules[index]);
      }
    }
  }
}

</script>